function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 4a2 2 0 012-2h16a2 2 0 012 2v3h-2V4H4v14h7v2H4a2 2 0 01-2-2V4z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 7a1 1 0 100-2 1 1 0 000 2zM9 7a1 1 0 100-2 1 1 0 000 2zM13 6a1 1 0 11-2 0 1 1 0 012 0z",
  fill: "#4038FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 8a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z",
  fill: "#4038FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.134 20.899L19.535 17h-5.07l-2.599 3.898 1.664 1.11L15.535 19h2.93l2.005 3.008 1.664-1.11z",
  fill: "#4038FF"
});

var SvgGatewayOperator = function SvgGatewayOperator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgNEMyIDIuODk1NDMgMi44OTU0MyAyIDQgMkgyMEMyMS4xMDQ2IDIgMjIgMi44OTU0MyAyMiA0VjdIMjBWNEg0VjE4SDExVjIwSDRDMi44OTU0MyAyMCAyIDE5LjEwNDYgMiAxOFY0WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNNiA3QzYuNTUyMjggNyA3IDYuNTUyMjggNyA2QzcgNS40NDc3MiA2LjU1MjI4IDUgNiA1QzUuNDQ3NzIgNSA1IDUuNDQ3NzIgNSA2QzUgNi41NTIyOCA1LjQ0NzcyIDcgNiA3WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNOSA3QzkuNTUyMjggNyAxMCA2LjU1MjI4IDEwIDZDMTAgNS40NDc3MiA5LjU1MjI4IDUgOSA1QzguNDQ3NzIgNSA4IDUuNDQ3NzIgOCA2QzggNi41NTIyOCA4LjQ0NzcyIDcgOSA3WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNMTMgNkMxMyA2LjU1MjI4IDEyLjU1MjMgNyAxMiA3QzExLjQ0NzcgNyAxMSA2LjU1MjI4IDExIDZDMTEgNS40NDc3MiAxMS40NDc3IDUgMTIgNUMxMi41NTIzIDUgMTMgNS40NDc3MiAxMyA2WiIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDhDMTQuNzkwOCA4IDEzIDkuNzkwODYgMTMgMTJDMTMgMTQuMjA5MSAxNC43OTA4IDE2IDE3IDE2QzE5LjIwOTEgMTYgMjEgMTQuMjA5MSAyMSAxMkMyMSA5Ljc5MDg2IDE5LjIwOTEgOCAxNyA4Wk0xNSAxMkMxNSAxMC44OTU0IDE1Ljg5NTQgMTAgMTcgMTBDMTguMTA0NiAxMCAxOSAxMC44OTU0IDE5IDEyQzE5IDEzLjEwNDYgMTguMTA0NiAxNCAxNyAxNEMxNS44OTU0IDE0IDE1IDEzLjEwNDYgMTUgMTJaIiBmaWxsPSIjNDAzOEZGIi8+CjxwYXRoIGQ9Ik0yMi4xMzQzIDIwLjg5ODdMMTkuNTM1MiAxN0gxNC40NjQ4TDExLjg2NjIgMjAuODk3OUwxMy41MzAzIDIyLjAwNzNMMTUuNTM1MiAxOUgxOC40NjQ4TDIwLjQ3MDIgMjIuMDA4MUwyMi4xMzQzIDIwLjg5ODdaIiBmaWxsPSIjNDAzOEZGIi8+Cjwvc3ZnPgo=";
export { SvgGatewayOperator as ReactComponent };